export interface TicketSale {
  id: string
  transaction_id: string
  target: string
  target_email: string
  target_identifier: string
  age_group_id: number
  product_id: string
  product_name: string
  zone_from_id: string
  zone_from_name: string
  zone_to_id: string
  zone_to_name: string
  validity_starts: Date
  validity_ends: Date
  group_size: number
  authority: string
  ticket_data: string
  created: Date
  updated: Date
}

export enum TicketSaleTabType {
  DETAILS = 'details',
  QR_CODE = 'qr_code'
}

export interface FetchTicketSaleListParams {
  page: number
  ordering: string
}

export interface TicketProduct {
  id: string
  name: string
}

export interface FetchTicketSaleTargetListParams {
  page: number
  ordering: string
}

export interface FetchAllTicketSaleTargetListParams {
  disable_pagination: boolean
}

export interface TicketSaleTarget {
  id: string
  identifier: string
  description: string
  authority: string
  created: Date
  updated: Date
}

export enum TicketSaleTargetTabType {
  DETAILS = 'details'
}

interface AgeGroup {
  id: number
  name: string
}

interface Zone {
  id: number
  name: string
}

export interface SalesChannel {
  external_id: string
}

export interface SalesChannelInfo {
  zones: Zone[]
  age_groups: AgeGroup[]
}
